// extracted by mini-css-extract-plugin
export default {"addressSection":"gY-z","disabled":"hY-z","sectionButtons":"iY-z","logo":"jY-z"};